'use client';

import React from 'react';
import { Eye, TrendingUp } from 'lucide-react';
import { AreaChart, Area, ResponsiveContainer, Tooltip } from 'recharts';

const sparkData = [
  { day: 'day-1', v: 3200 }, { day: 'day-2', v: 3450 }, { day: 'day-3', v: 3100 },
  { day: 'day-4', v: 4800 }, { day: 'day-5', v: 3600 }, { day: 'day-6', v: 3900 },
  { day: 'day-7', v: 5240 },
];

export default function ImpressionsCard() {
  return (
    <div className="h-full bg-white border border-[#e7e7e7] rounded-[5px] p-5 hover:shadow-[rgba(150,25,50,0.1)_0px_10px_30px] transition-all duration-200 hover:-translate-y-0.5">
      <div className="flex items-start justify-between mb-3">
        <div>
          <p className="text-xs font-500 uppercase tracking-wide text-[#696969] mb-1">
            Branded Impressions
          </p>
          <p className="text-3xl font-700 tabular-nums text-[#39364E]">
            24,830
          </p>
          <p className="text-xs text-[#696969] mt-1">Last 7 days</p>
        </div>
        <div className="flex flex-col items-end gap-2">
          {/* Smarty-style icon wrapper: teal bg */}
          <div
            className="w-[50px] h-[50px] rounded-[5px] flex items-center justify-center"
            style={{ backgroundColor: 'rgb(217, 243, 246)' }}
          >
            <Eye size={22} className="text-[#39364E]" />
          </div>
          <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 border border-emerald-200">
            <TrendingUp size={11} className="text-emerald-600" />
            <span className="text-[11px] font-600 text-emerald-700 tabular-nums">+18.4%</span>
          </div>
        </div>
      </div>
      <div className="h-16">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={sparkData} margin={{ top: 2, right: 0, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="impressionsGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#961932" stopOpacity={0.2} />
                <stop offset="95%" stopColor="#961932" stopOpacity={0} />
              </linearGradient>
            </defs>
            <Area
              type="monotone"
              dataKey="v"
              stroke="#961932"
              strokeWidth={2}
              fill="url(#impressionsGrad)"
              dot={false}
            />
            <Tooltip
              content={({ active, payload }) => {
                if (!active || !payload?.length) return null;
                return (
                  <div className="bg-white border border-[#e7e7e7] rounded-[5px] px-2 py-1 shadow-[rgba(150,25,50,0.1)_0px_4px_12px] text-xs font-500 text-[#39364E]">
                    {payload?.[0]?.value?.toLocaleString()}
                  </div>
                );
              }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <p className="text-[11px] text-[#696969] mt-2">
        vs <span className="font-500 text-[#39364E]">20,975</span> prev 7d
      </p>
    </div>
  );
}